export const pageSizeChoices = [10, 20, 50, 100, 300, 500, 1000];

export type PaginationPreference = {
  page: number;
  pageSize: number;
};

const defaultPreference: PaginationPreference = {page: 1, pageSize: 25};
const key = (datasetKey: string) => `admin-id-express-pagination:${datasetKey}`;

export const normalizePageSize = (value: unknown) => {
  const numeric = Number(value);
  return pageSizeChoices.includes(numeric) ? numeric : defaultPreference.pageSize;
};

export const normalizePage = (value: unknown) => Math.max(1, Number(value) || defaultPreference.page);

export const readPaginationPreference = (datasetKey: string): PaginationPreference => {
  try {
    const parsed = JSON.parse(localStorage.getItem(key(datasetKey)) || "{}");
    return {
      page: normalizePage(parsed.page),
      pageSize: normalizePageSize(parsed.pageSize),
    };
  } catch {
    return defaultPreference;
  }
};

export const writePaginationPreference = (datasetKey: string, preference: PaginationPreference) => {
  try {
    localStorage.setItem(key(datasetKey), JSON.stringify({
      page: normalizePage(preference.page),
      pageSize: normalizePageSize(preference.pageSize),
    }));
  } catch {
    /* Pagination still works when storage is unavailable. */
  }
};
